import BackgroundPaths from "./BackgroundPaths";

/**
 * Full-width flowing path divider between sections.
 */
export const SectionDivider = () => (
  <div className="relative h-8 sm:h-10 w-full overflow-hidden opacity-50" aria-hidden="true">
    <BackgroundPaths
      variant="wave"
      stroke="rgba(74, 63, 107, 0.15)"
      strokeWidth={1}
      className="absolute inset-0 w-full h-full"
    />
  </div>
);

export default SectionDivider;
